import { render } from "./list-adder.vue?vue&type=template&id=4da54c94"
import script from "./list-adder.vue?vue&type=script&lang=js"
export * from "./list-adder.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../../opt/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__